export enum BulkCeaseCompanyOfficeholderStepsEnum {
  FormDescription = 0,
  CeaseCompanyOfficeholder = 1,
  Summary = 2,
}
